import { FilterBuilder } from '../Types';

import { CanonicalRegistration } from 'ha/constants/Filters';

const registrationBuilder: FilterBuilder = params => {
  const registration = params.registration;

  if (!registration) {
    return '';
  }

  return {
    [CanonicalRegistration.Possible]: 'facility_registration_possible:yes',
    [CanonicalRegistration.NotPossible]: 'facility_registration_possible:no',
  }[registration];
};

export default registrationBuilder;
